/* Big Beetle Books — shop/collection interactions (light parallax + reveal) */
(function(){
  var root = document.getElementById('bbb-shop');
  if(!root) return;

  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var reduce = mqReduce.matches;

  /* --- background parallax (fixed-ish washes, clipped to section) --- */
  var layers = [].slice.call(root.querySelectorAll('.shop-bg [data-speed]'));
  var scrollY = 0, ticking = false;

  function update(){
    for(var i=0;i<layers.length;i++){
      var el = layers[i];
      var sp = parseFloat(el.getAttribute('data-speed')) || 0;
      el.style.transform = 'translate3d(0,' + (scrollY * sp) + 'px,0)';
    }
    ticking = false;
  }
  function onScroll(){ scrollY = window.scrollY || 0; if(!ticking){ requestAnimationFrame(update); ticking = true; } }

  if(!reduce && layers.length){
    window.addEventListener('scroll', onScroll, { passive:true });
    update();
  }

  /* --- reveal on scroll --- */
  var revealEls = [].slice.call(root.querySelectorAll('.shop-head, .shop-card'));
  if(!reduce && 'IntersectionObserver' in window){
    revealEls.forEach(function(el){ el.classList.add('reveal'); });
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('vis'); io.unobserve(e.target); }
      });
    }, { threshold:0.08, rootMargin:'0px 0px -6% 0px' });
    revealEls.forEach(function(el){ io.observe(el); });
  }
})();
